module.exports = __webpack_public_path__ + "img/jie-qu-gong-gao.e1427634.jpg";